function init() {
    if ($('#locations').length){
        $('.tab-triggers__item').click(function() {
            let tabLoc = $(this).attr('tab');

            // Set the tab to be active
            $('.tab-triggers__item').removeClass('tab-triggers__item--active');
            $(this).addClass('tab-triggers__item--active');

            // Show the tab
            $('.location-block').removeClass('location-block--active');
            $('.location-block').each(function(){
                if($(this).attr('location') === tabLoc)
                    $(this).addClass('location-block--active');
            });
        });
    }
}

export default { init }

